/*
* Created by Rishabh Kumar on 25/11/20
* */

/** @jsx jsx */
import * as React from "react"
import { jsx } from "@emotion/core"
import IStaticDataValue from "../../../../common/models/IStaticDataValue";

interface IRadioBtnGroupProps {
    items: IStaticDataValue[],
    handleClick: (val: string | number) => void
    inline?: boolean
}

export const RadioBtnGroup = (props: IRadioBtnGroupProps) => {
    const [selectedBtnIndex, setSelectedBtnIndex] = React.useState<number>(null)

    const handleBtnClick = (val: string, idx: number) => {
        setSelectedBtnIndex(idx)
        props.handleClick && props.handleClick(val)
    }

    return (
        <div className={"radio-btn-group"}>
            {
                (props.items || []).map((item: IStaticDataValue, index: number) => <RadioBtnItem item={item} isActive={index === selectedBtnIndex} onClick={val => handleBtnClick(val, index)} />)
            }
        </div>
    )
}

export const RadioBtnItem = (props: {item: IStaticDataValue, onClick: (val: string) => void, isActive: boolean}) => {

    return (
        <div className={"radio-btn-item"} onClick={() => props.onClick && props.onClick(props.item.internalValue)}>
            <div className={`radio-btn-outer-circle ${props.isActive ? "active" : ""}`}>
                <div className={"radio-btn-inner-circle"}/>
            </div>
            <span>{props.item ? props.item.displayValue : ""}</span>
        </div>
    )
}